import { render, staticRenderFns } from "./TransportationExpenses.vue?vue&type=template&id=fcdd491e"
import script from "./TransportationExpenses.vue?vue&type=script&lang=js"
export * from "./TransportationExpenses.vue?vue&type=script&lang=js"
import style0 from "./TransportationExpenses.vue?vue&type=style&index=0&id=fcdd491e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports